export const AUTH_URL = Object.freeze(
  process.env.REACT_APP_AUTH_URL ?? 'https://auth.yellowdogsoftware.com'
);

export const SHEPARD_URL =
  process.env.REACT_APP_SHEPARD_URL ?? 'https://shepard.yellowdog.software';

export const USE_MODAL_AUTH = process.env.REACT_APP_USE_MODAL_AUTH === 'true';
